module.exports = __webpack_public_path__ + "static/bmx2-262d4fc72e24980735eed634d09718e7.jpg";